import { Injectable } from "@angular/core";
import { ApiService } from "../../shared/services/api/api.service";

@Injectable({
    providedIn: 'root'
})
export class WorklistService {
    constructor(private readonly apiService: ApiService) { }
    create(filter: any) {
        return this.apiService.post<any[]>('worklist/create', filter);
    }

    update(id: number, payload: any) {
        return this.apiService.post<any>(`worklist/update/${id}`, payload);
    }

  find(id: number) {
    return this.apiService.post<any>(`worklist/workfind/${id}`);
  }

    list() {
        return this.apiService.get('worklist', {});
    }

    getFilteredList(filter: any) {
        return this.apiService.post<any>(`worklist/filter`, filter);

    }

    filterMobileStatus(filter: any) {
        return this.apiService.post<any>(`worklist/filterMobileStatus`, filter.filter);

    }

    getStatusLogs(id: number) {
        return this.apiService.get<any>(`worklist/status-logs/${id}`);

    }

    getAlarmDatas(filter: any) {
        return this.apiService.post<any>(`worklist/filter-alarm-data`, filter);

    }
}
